import { useMutation, ApolloError, DataProxy } from '@apollo/client';

import { useError } from '@/hooks/useError';
import { useCompanyData } from '@/contexts/CompaniesDataContext';

import { ENTITY_PAGE_UNFOLLOW_MUTATION } from '@/graphql/mutations';

const useUnfollowCompanyMutation = ({
  entityPageId,
}: {
  entityPageId: string;
}) => {
  // @ts-expect-error TS(2339) FIXME: Property 'showError' does not exist on type 'unkno... Remove this comment to see the full error message
  const { showError } = useError();
  const { unfollowCompany } = useCompanyData();
  const [handleUnfollowCompany] = useMutation(ENTITY_PAGE_UNFOLLOW_MUTATION, {
    update: (cache: DataProxy, props: any) => {
      if (props.data?.entityPageUnfollow?.error) {
        showError({
          message: props.data?.entityPageUnfollow?.error?.message,
        });
      } else {
        unfollowCompany({ entityPageId });
      }
    },
    onError: (error: ApolloError) => {
      showError({ message: error.message, error });
    },
  });

  return {
    handleUnfollow: () =>
      handleUnfollowCompany({ variables: { followedId: entityPageId } }),
  };
};

export { useUnfollowCompanyMutation };
